module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAMCAMAAABRJ730AAAAAXNSR0IArs4c6QAAADxQTFRFAAAAS1rwR1XxQ1HySVXzRlHoR1LrSFn0SVfvSFbvSFbuSFbuSVXvSVbuSVbvSVbvSFfwSFbuSFXuSFbuDoUUFwAAABN0Uk5TABESExUWGS5tu8PEy8/P09fY/vpXSg0AAABPSURBVBjTdchLEoAgDMDQqFB/aMXe/64uHIcKml0e/LSk+HrZZ4Bk6l2yrQBRvUu2raf2ot693h4AObw+XisENR0bhah2tgpBvxSGqStzASDYA+uI5/mRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/filtrate_down_a.png
// module id = gMEj
// module chunks = 0